import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  FaWarehouse,
  FaSchool,
  FaStore,
  FaMap,
  FaGooglePlay,
  FaQuestion,
} from 'react-icons/fa';
import { FiArrowLeft, FiMenu } from 'react-icons/fi';

import { setSidebarVisible } from '../../../../support/store/SidebarReducer';
import './stylesSpaceNotExist.css';

function useSpaceNotExist() {
  const location = useLocation();
  const history = useHistory();
  const spaceNickname = location.pathname.split('/')[1];
  const dispatch = useDispatch();

  const handleMenuClick = () => dispatch(setSidebarVisible({ visible: true }));
  const handleBackClick = () => history.goBack();
  const handleGoToPlayStore = () => { window.location.href = 'https://play.google.com/store/apps/details?id=com.locall.app'; };
  const handleGoToMap = () => history.push('/map');

  return ({
    localStates: {
      spaceNickname,
    },
    eventHandlers: {
      handleGoToMap,
      handleGoToPlayStore,
      handleMenuClick,
      handleBackClick,
    },
  });
}

export default function SpaceNotExist() {
  const { localStates, eventHandlers } = useSpaceNotExist();
  return (
    <div className="container">
      <section className="banner">
        <section className="nav-container">
          <FiArrowLeft onClick={eventHandlers.handleBackClick} color="#000" size={32} style={{ cursor: 'pointer' }} />
          <FiMenu onClick={eventHandlers.handleMenuClick} color="#000" size={32} style={{ cursor: 'pointer' }} />
        </section>

        <h2>{`Não foi possível localizar o espaço @${localStates.spaceNickname}`}</h2>

        <div className="image">
          <div className="image-builds">
            <FaSchool className="big-build" size={75} color="#bcafa4" />
            <div className="question-icon">
              <FaQuestion size={40} color="#CF5648" />
            </div>
            <FaStore className="small-build" size={48} color="#bcafa4" />
            <FaWarehouse className="big-build" size={75} color="#bcafa4" />
          </div>
        </div>
      </section>

      <section className="error-message">
        <div className="box-options">
          <div className="option">
            <p>Descubra outros espaços no mapa Locall ou crie o seu pelo aplicativo.</p>

            <button className="red-button" type="button" onClick={eventHandlers.handleGoToMap}>
              <FaMap size={22} strokeWidth="3" color="#FFF" />
              <h4>Mapa Locall</h4>
            </button>

            <button className="soft-button" type="button" onClick={eventHandlers.handleGoToPlayStore}>
              <FaGooglePlay size={22} strokeWidth="3" color="#999" />
              <h4>Baixar app</h4>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
